import { Alert, Box, LinearProgress } from '@mui/material';
import { ReactElement } from 'react';
import { DataTable, ReferenceManyField, TextField, useRecordContext } from 'react-admin';
import type { ActionLogResource } from '../../Entities/ActionLog';

export default function ChangesPanel(): ReactElement {
  const record = useRecordContext<ActionLogResource>();

  if (!record) {
    return <LinearProgress />;
  }

  if (record.attributes?.action !== 'update') {
    return <Alert severity="info">Changed attributes are only recorded for update actions.</Alert>;
  }

  return (
    <Box
      sx={{
        backgroundColor: 'action.hover',
        borderLeft: 2,
        borderColor: 'action.selected',
        mb: 1,
        px: 1.5,
        py: 1,
      }}
    >
      <ReferenceManyField reference="action_log_changes" target="action_log.id" perPage={1000}>
        <DataTable
          rowClick={false}
          bulkActionButtons={false}
          size="small"
          sx={{
            '& .RaDataTable-headerCell': { backgroundColor: 'transparent' },
            '& tbody tr:last-child td': { borderBottom: 0 },
            maxWidth: { md: 900 },
            width: '100%',
          }}
        >
          <DataTable.Col source="attributes.attribute_name" label="Attribute" />
          <DataTable.Col source="attributes.old_value" label="Old Value">
            <TextField emptyText="-" source="attributes.old_value" />
          </DataTable.Col>
          <DataTable.Col source="attributes.new_value" label="New Value">
            <TextField emptyText="-" source="attributes.new_value" />
          </DataTable.Col>
        </DataTable>
      </ReferenceManyField>
    </Box>
  );
}
